module.exports = __webpack_public_path__ + "img/Bar@3x@2x.9742ee32.png";